<template>
  <div class="images">
    <v-container class="d-flex flex-column justify-center">
      <v-img :src="`${apiUrl}/image/${filename}`" />
      <v-sheet v-if="next || previous" class="mt-2 py-1 px-4" color="secondary" elevation="1">
        <v-row>
          <v-col class="pa-1" cols="6">
            <v-btn block :disabled="!previous" :to="`/image/${previous}`">Previous</v-btn>
          </v-col>
          <v-col class="pa-1" cols="6">
            <v-btn block :disabled="!next" :to="`/image/${next}`">Next</v-btn>
          </v-col>
        </v-row>
      </v-sheet>
      <v-sheet class="mt-2 pa-1" color="accent" elevation="1">
        <v-btn class="ma-1" :href="`${apiUrl}/image/${filename}`" target="_blank">Full size</v-btn>
        <v-btn class="ma-1 btn--no-click" outlined>Size: {{ info.size }}</v-btn>
        <v-btn class="ma-1 btn--no-click" v-if="info.artist" outlined>Artist: {{ info.artist }}</v-btn>
        <v-btn class="ma-1" v-if="info.source" :href="info.source" target="_blank">Source: {{ sourceDomain }}</v-btn>
        <!-- <v-btn class="ma-1 btn--no-click" v-if="info.author" outlined>Uploaded by: {{ info.author }}</v-btn> -->
        <v-btn class="ma-1 btn--no-click" outlined>Created: {{ info.creation }} UTC</v-btn>
        <v-btn
          class="ma-1"
          v-for="character in info.categories"
          :key="character"
          :to="{ name: 'Character', params: { id: character } }"
        >Character: {{ characters[character] }}</v-btn>
        <ReportDialog :image="filename" />
      </v-sheet>
    </v-container>
    <v-container class="d-flex flex-column justify-center">
      <Disqus />
    </v-container>
  </div>
</template>

<script>
import axios from '../plugins/axios'
import characters from '../enums/characters'
import ReportDialog from '../components/ReportDialog'

export default {
  components: {
    ReportDialog
  },
  data: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    characters,
    info: {}
  }),
  computed: {
    filename () {
      return this.$route.params.name
    },
    sourceDomain () {
      return this.info.source?.match(/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/)[0] || null
    },
    next () {
      return this.$store.getters.next
    },
    previous () {
      return this.$store.getters.previous
    }
  },
  async created () {
    this.$store.dispatch('setCurrent', this.filename)

    try {
      const result = await axios.get(`/info/${this.filename}`)
      this.info = result.data.info
    } catch (error) {
      this.$router.replace({ name: 'NotFound' })
    }
  }
}
</script>

<style>
.btn--no-click {
  cursor: default !important;
  pointer-events: none !important;
}
</style>
